import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum InputValueState {
    error,
    normal,
    init,
}

export enum SystemSettingInputSemantic {
    secondary = 'secondary',
    tertiary = 'tertiary',
}

export enum SystemSettingInputWeight {
    regular = 'regular',
    medium = 'medium',
    semiBold = 'semi-bold',
    bold = 'bold',
}

@Component({
    selector: 'app-system-setting-input',
    templateUrl: './system-setting-input.component.html',
    styleUrls: ['./system-setting-input.component.css'],
    standalone: false,
})
export class SystemSettingInputComponent implements OnInit, OnChanges {
    readonly SECONDARY = SystemSettingInputSemantic.secondary;
    readonly TERTIARY = SystemSettingInputSemantic.tertiary;

    readonly REGULAR = SystemSettingInputWeight.regular;
    readonly MEDIUM = SystemSettingInputWeight.medium;
    readonly SEMIBOLD = SystemSettingInputWeight.semiBold;
    readonly BOLD = SystemSettingInputWeight.bold;

    readonly ERROR = InputValueState.error;
    readonly NORMAL = InputValueState.normal;
    readonly INIT = InputValueState.init;

    @Input() name: string;
    @Input() label: string;
    @Input() value: string;
    @Input() unit: string = '';
    @Input() maxLength: number = 20;
    @Input() inputErrorMessage: string = '';
    @Input() semantic: SystemSettingInputSemantic = this.SECONDARY;
    @Input() weight: SystemSettingInputWeight = this.REGULAR;
    @Input() showLenCounter: boolean = false;
    @Input() showErrorMessage: boolean = false;
    @Input() showErrorInitial: boolean = false;

    @Output() onBlur = new EventEmitter<void>();
    @Output() onInputChange = new EventEmitter<{ name: string; value: string }>();
    @Output() onInputKeyDown = new EventEmitter<{ event: KeyboardEvent; value: string }>();

    inputValue = '';
    focus = false;
    inputValueCheck = this.INIT;

    constructor(private translateService: TranslateService) {}

    ngOnInit() {
        this.inputValue = this.value !== undefined ? this.value : '';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.inputValue = this.value;
            if (!changes.value?.isFirstChange()) this.onCheckInputValue();
        }

        if (this.showErrorInitial && changes.inputErrorMessage && !changes.inputErrorMessage?.isFirstChange()) {
            this.onCheckInputValue();
        }

        if (changes.value?.isFirstChange() && this.showErrorInitial) this.onCheckInputValue();
    }

    onCheckInputValue() {
        if (this.inputErrorMessage) {
            this.inputValueCheck = this.ERROR;
        } else {
            this.inputValueCheck = this.NORMAL;
        }
    }

    inputFocus() {
        this.focus = true;
    }

    inputBlur() {
        this.focus = false;
        this.onBlur.emit();
    }

    onChange(value: string) {
        this.onInputChange.emit({ name: this.name, value: value });
        this.onCheckInputValue();
    }

    inputKeyDown(event: KeyboardEvent) {
        this.onInputKeyDown?.emit({ event, value: this.inputValue });
    }

    getErrorString() {
        return this.translateService.instant(this.inputErrorMessage, { max: this.maxLength });
    }
}
